import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Modal,
  Row,
  Spinner,
  Tab,
  Tabs,
  Table
} from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import api from 'helpers/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileInvoice,
  faFileArchive,
  faDownload
} from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';
import IconButton from 'components/common/IconButton';
import Flex from 'components/common/Flex';
import { DownloadHS, Download, newDowload } from 'helpers/utils';
var jszip = require('jszip');
var saveAs = require('file-saver');

const Activity = ({
  activity: { processo, evento, data, processoId, importador, ident_cli_pro },
  operacao,
  isLast
}) => {
  // let operacao =
  //   operacao === 'Agenciamento' ? 'A' : operacao === 'Exportação' ? 'E' : 'I';
  const [dataFiles, setDataFiles] = useState([]);
  const [modalShowArquivo, setModalShowArquivo] = React.useState(false);
  const [realizouConsulta, setRealizouConsulta] = React.useState(false);
  const [isDownloading, setisDownloading] = React.useState(false);
  const [existeArquivos, setExisteArquivos] = useState(false);
  const [isLoading, setLoadingFile] = React.useState(false);

  const parseDateString = dateString => {
    const [day, month, year] = dateString.split('/'); // Exemplo: "31/12/2023"
    return new Date(`${year}-${month}-${day}`); // Converte para YYYY-MM-DD
  };

  const handleFiles = async (idProcesso, operacao) => {
    setDataFiles([]);
    setRealizouConsulta(false);
    setModalShowArquivo(true);
   
    if (operacao === 'I' || operacao === 'E') {
      try {
        const result = await api.get(`/api/empresas/arquivos/${idProcesso}`);
        if (result.data.result.length > 0) {
          setExisteArquivos(true);
          setDataFiles(result.data.result);
        }
      } catch (err) {
      } finally {
        setRealizouConsulta(true);
      }

      // }else if(operacao === 'A'){
      //   try {
      //     const result = await api.get(`/api/hs/arquivos/${idProcesso}`);
      //     if (result.data.result.length > 0) {
      //       setExisteArquivos(true);
      //       setDataFiles(result.data.result);
      //     }
      //   } catch (err) {
      //   } finally {
      //     setRealizouConsulta(true);
      //   }
    }
  };

  const FileDownloadFilesBlob = async (dataFile, qual) => {
    setLoadingFile(true);
    var zip = new jszip();
    dataFile.forEach(async element => {
      if (qual === 'Todos') {
        if (element['Folder'] === 'Processo' || element['Folder'] === null) {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('processo');
          img.file(element['FileName'], blob);
        }
        if (element['Folder'] === 'Financeiro') {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('financeiro');
          img.file(element['FileName'], blob);
        }
      } else if (qual === 'Processo') {
        if (element['Folder'] === 'Processo' || element['Folder'] === null) {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('processo');
          img.file(element['FileName'], blob);
        }
      } else if (qual === 'Financeiro') {
        if (element['Folder'] === 'Financeiro') {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('financeiro');
          img.file(element['FileName'], blob);
        }
      }
    });

    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, 'arquivos.zip');
      setLoadingFile(false);
    });
  };

  const getAll = async id => {
    const result = await api.get('/api/empresas/file/' + id);
    var blob = newDowload(
      result.data.result[0].File.data,
      'application/' +
        result.data.result[0].FileName.substring(
          result.data.result[0].FileName.indexOf('.') + 1
        ),
      result.data.result[0].FileName
    );
    return blob;
  };

  const getUrlFile = async id => {
    const result = await api.get(`/api/empresas/file/${id}`);
    Download(
      result.data.result[0].File.data,
      'application/' +
        result.data.result[0].FileName.substring(
          result.data.result[0].FileName.indexOf('.') + 1
        ),
      result.data.result[0].FileName
    );
    // } else if (operacao[0] === 'T') {
    //   setisDownloading(true);
    //   const result = await api.get(`/api/empresas/arquivoURL/${id}`);

    //   let a = document.createElement('a');
    //   a.href = result.data.result.url;
    //   a.download = result.data.result.filename;
    //   setisDownloading(false);
    //   a.click();
  };

  return (
    <>
      <Row
        className={classNames(
          'g-3 recent-activity-timeline recent-activity-timeline-primary',
          {
            'pb-x1': !isLast,
            'recent-activity-timeline-past': status === 'completed',
            'recent-activity-timeline-current': status === 'current'
          }
        )}
      >
        <Col xs="auto" className="ps-4 ms-2">
          <div className="ps-2">
            <div className="icon-item icon-item-sm rounded-circle bg-200 shadow-none">
              {/* <FontAwesomeIcon icon={icon} className="text-primary" /> */}
            </div>
          </div>
        </Col>
        <Col>
          <Row
            className={classNames('g-3', { 'border-bottom pb-x1': !isLast })}
          >
            <Col>
              {operacao === 'E' ? (
                <>
                  <h6 className="text-800 mb-1" style={{ fontSize: '0.625em' }}>
                    {processo} | Ref: {ident_cli_pro} | Importador: {importador}
                  </h6>
                </>
              ) : (
                <>
                  <h6 className="text-800 mb-1" style={{ fontSize: '0.625em' }}>
                    {processo} | Ref: {ident_cli_pro} | Exportador: {importador}
                  </h6>
                </>
              )}

              <p
                className="fs--1 text-600 mb-0"
                style={{ fontSize: '0.625em' }}
              >
                {evento}
              </p>
            </Col>
            <Col xs="auto">
              <p
                className="fs--2 text-500 mb-0"
                style={{ fontSize: '0.625em' }}
              >
                {data}
              </p>
            </Col>
            <Col xs="auto">
              <Link
                to={{
                  // pathname: '/app/process/process-details/' + operacao + '&' + id
                  pathname:
                    '/app/process/process-details/' +
                    operacao +
                    '&' +
                    processoId
                }}
              >
                {/* <strong>{processoid}</strong> */}
                <strong>
                  {/* {processo} */}
                  <FontAwesomeIcon
                    icon={faFileInvoice}
                    title="Detalhes"
                    style={{ cursor: 'pointer' }}
                    size="lg"
                  />
                </strong>{' '}
              </Link>{' '}
              {operacao !== 'A' ? (
                <>
                  <Link
                    to="#"
                    onClick={() => handleFiles(processoId, operacao)}
                  >
                    <strong>
                      {/* {processo} */}
                      <FontAwesomeIcon
                        icon={faFileArchive}
                        title="Arquivos"
                        style={{ cursor: 'pointer' }}
                        size="lg"
                      />
                    </strong>{' '}
                  </Link>
                </>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      {/*Modal Arquivo*/}
      <Modal
        show={modalShowArquivo}
        onHide={() => setModalShowArquivo(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">Arquivos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {realizouConsulta ? (
            <>
              <>
                <IconButton
                  size="sm"
                  alt="Baixar Arquivo"
                  aria-label="Baixar Arquivo"
                  onClick={() => FileDownloadFilesBlob(dataFiles, 'Todos')}
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }}
                >
                  Baixar Todos(Processo / Financeiro)
                  <FontAwesomeIcon icon={faDownload} />
                </IconButton>

                {isLoading ? (
                  <>
                    <Spinner style={{ color: 'black' }} size="0.2rem" />

                    <span style={{ color: 'black', fontSize: '0.75rem' }}>
                      Aguarde....
                    </span>
                  </>
                ) : (
                  <></>
                )}
              </>
              <Tabs defaultActiveKey="processo" id="uncontrolled-tab-example">
                <Tab
                  eventKey="processo"
                  title="Processo"
                  className="p-3"
                  style={{ fontSize: '0.875rem' }}
                >
                  <Table size="sm">
                    <thead>
                      <tr>
                        <th style={{ fontSize: '0.875rem' }}>
                          Data
                          {isDownloading ? (
                            <>
                              <Spinner size="1rem" style={{ color: 'black' }} />
                            </>
                          ) : (
                            <></>
                          )}
                        </th>
                        <th style={{ fontSize: '0.875rem' }}>Descricao</th>
                        <th
                          style={{
                            alignItems: 'center',
                            textAlign: 'center',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            fontSize: '0.875rem'
                          }}
                        >
                          Download
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataFiles
                        .filter(arq => arq.Folder !== 'Financeiro')
                        .sort(
                          (a, b) =>
                            parseDateString(b.data) - parseDateString(a.data)
                        )
                        .map(row => {
                          return (
                            <>
                              <tr key={row.iFileSystemID}>
                                <td style={{ fontSize: '0.75rem' }}>
                                  {row.data}
                                </td>
                                <td style={{ fontSize: '0.75rem' }}>
                                  {row.FileName}
                                </td>
                                <td
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  {' '}
                                  <IconButton
                                    size="sm"
                                    alt="Baixar Arquivo"
                                    aria-label="Baixar Arquivo"
                                    onClick={() =>
                                      getUrlFile(row.iFileSystemID)
                                    }
                                    style={{
                                      marginLeft: 'auto',
                                      marginRight: 'auto'
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faDownload} />
                                  </IconButton>
                                </td>
                              </tr>
                            </>
                          );
                        })}
                    </tbody>
                  </Table>
                </Tab>
                <Tab eventKey="financeiro" title="Financeiro" className="p-3">
                  <Table size="sm">
                    <thead>
                      <tr>
                        <th style={{ fontSize: '0.875rem' }}>
                          Data
                          {isDownloading ? (
                            <>
                              <Spinner size="1rem" style={{ color: 'black' }} />
                            </>
                          ) : (
                            <></>
                          )}
                        </th>
                        <th style={{ fontSize: '0.875rem' }}>descricao</th>
                        <th
                          style={{
                            alignItems: 'center',
                            textAlign: 'center',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            fontSize: '0.875rem'
                          }}
                        >
                          Download
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataFiles
                        .filter(arq => arq.Folder === 'Financeiro')
                        .sort(
                          (a, b) =>
                            parseDateString(b.data) - parseDateString(a.data)
                        )
                        .map(row => {
                          return (
                            <>
                              <tr key={row.iFileSystemID}>
                                <td style={{ fontSize: '0.75rem' }}>
                                  {row.data}
                                </td>
                                <td style={{ fontSize: '0.75rem' }}>
                                  {row.FileName}
                                </td>
                                <td
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  {' '}
                                  <IconButton
                                    size="sm"
                                    alt="Baixar Arquivo"
                                    aria-label="Baixar Arquivo"
                                    onClick={() =>
                                      getUrlFile(row.iFileSystemID)
                                    }
                                    style={{
                                      marginLeft: 'auto',
                                      marginRight: 'auto'
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faDownload} />
                                  </IconButton>
                                </td>
                              </tr>
                            </>
                          );
                        })}
                    </tbody>
                  </Table>
                </Tab>
              </Tabs>
            </>
          ) : (
            <>
              <Flex justifyContent="center">
                <div className="p-2">
                  <Spinner />
                  <span> Aguarde carregando ...</span>
                </div>
              </Flex>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShowArquivo(false)} size="sm">
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const AtividadesRecentesEmbarque = ({ title, data, height, operacao }) => {
  let tpoperacoes =
    operacao === 'AGENCIAMENTO' ? 'A' : operacao === 'IMPORTAÇÃO' ? 'I' : 'E';
  return (
    <Card className="h-auto recent-activity-card">
      <FalconCardHeader title={title} titleTag="h6" />
      <SimpleBarReact style={{ height: height }}>
        <Card.Body className="ps-2 recent-activity-body-height">
          {Array.isArray(data) && data.length > 0 ? (
            data.map((activity, index) => (
              <Activity
                key={activity.processo}
                activity={activity}
                title={title}
                isLast={index === data.length - 1}
                id={activity.processoId}
                operacao={tpoperacoes}
              />
            ))
          ) : (
            <div className="text-center p-3">Sem atividades recentes</div>
          )}
        </Card.Body>
      </SimpleBarReact>
    </Card>
  );
};

Activity.propTypes = {
  activity: PropTypes.shape({
    id: PropTypes.number,
    // title: PropTypes.string.isRequired,
    processo: PropTypes.string.isRequired,
    evento: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    processoId: PropTypes.number
  }),
  isLast: PropTypes.bool,
  operacao: PropTypes.string.isRequired
};

AtividadesRecentesEmbarque.propTypes = {
  data: PropTypes.arrayOf(Activity.propTypes.activity),
  height: PropTypes.string,
  operacao: PropTypes.string
};

export default AtividadesRecentesEmbarque;
